var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarClusterGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99998 15.1666V11.8333M2.99998 5.16659V1.83325M1.33331 3.49992H4.66665M1.33331 13.4999H4.66665M8.66665 2.49992L7.51053 5.50583C7.32252 5.99465 7.22852 6.23906 7.08233 6.44464C6.95277 6.62685 6.79358 6.78605 6.61137 6.91561C6.40578 7.06179 6.16137 7.15579 5.67255 7.3438L2.66665 8.49992L5.67256 9.65604C6.16137 9.84405 6.40578 9.93805 6.61137 10.0842C6.79358 10.2138 6.95277 10.373 7.08233 10.5552C7.22852 10.7608 7.32252 11.0052 7.51053 11.494L8.66665 14.4999L9.82277 11.494C10.0108 11.0052 10.1048 10.7608 10.251 10.5552C10.3805 10.373 10.5397 10.2138 10.7219 10.0842C10.9275 9.93805 11.1719 9.84405 11.6607 9.65604L14.6666 8.49992L11.6607 7.3438C11.1719 7.15579 10.9275 7.06179 10.7219 6.91561C10.5397 6.78605 10.3805 6.62685 10.251 6.44464C10.1048 6.23906 10.0108 5.99465 9.82276 5.50583L8.66665 2.49992Z",
    stroke: "url(#paint0_linear_700_2745)",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_700_2745",
    x1: 1.33331,
    y1: 15.1666,
    x2: 14.6666,
    y2: 1.83325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE46BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarClusterGradient);
export default __webpack_public_path__ + "static/media/star-cluster-gradient.b2f4356cbee96cde872534cfd9e46c4b.svg";
export { ForwardRef as ReactComponent };